import styled from '@emotion/styled'
import { Modal as AntModal } from 'antd'

// No header section / no borderline: the title is rendered inside the body,
// and the single confirm button is centered in a borderless footer.
export const Modal = styled(AntModal)<any>`
  .ant-modal-content {
    padding: 24px;
    border-radius: 12px;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .ant-modal-footer {
    margin-top: 24px;
    padding: 0;
    border-top: none;
  }

  .ant-btn-primary {
    box-shadow: none;
    height: auto;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 600;
    min-width: 120px;
  }
`

export const Title = styled('span')`
  font-family: 'Prompt';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #000000;
`

export const Description = styled('span')`
  font-family: 'Prompt';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #666666;
  white-space: pre-line;
`
